var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleQuoteRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.056,
    height: 57.202,
    viewBox: "0 0 63.056 57.202",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-double-quote-serif-right",
    "data-name": "Icon open-double-quote-serif-right",
    d: "M65.6,0V28.6H84.669A19,19,0,0,1,65.6,47.668V57.2A28.685,28.685,0,0,0,94.2,28.6V0Zm34.455,0V28.6h19.067a19,19,0,0,1-19.067,19.067V57.2a28.685,28.685,0,0,0,28.6-28.6V0Z",
    transform: "translate(-65.602)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleQuoteRight);
export default __webpack_public_path__ + "static/media/double-quote-right.3f4598ee66c1a72b7f596f7c5f5fd002.svg";
export { ForwardRef as ReactComponent };